let question = document.querySelectorAll(".question");
if(question){
  question.forEach(question => {
  question.addEventListener("click", event => {
    const active = document.querySelector(".question.active");
    if(active && active !== question ) {
      active.classList.toggle("active");
      active.nextElementSibling.style.maxHeight = 0;
    }
    question.classList.toggle("active");
    const answer = question.nextElementSibling;
    if(question.classList.contains("active")){
      answer.style.maxHeight = answer.scrollHeight + "px";
    } else {
      answer.style.maxHeight = 0;
    }
  })
})
}
$(document).ready(function(){
  $(".BannerCaro, .mobBannerCaro").owlCarousel({
      items: 1,
      loop: true,
      autoplay: true,
      margin: 10,
      dots: true,
      responsive: {
          0: {
              items: 1
          },
          600: {
              items: 1
          },
          1000: {
              items: 1
          }
      }
  });
  $('.site-nav--has-dropdown > a, .site-nav--has-dropdown > i').on('click', function(event) {
        event.preventDefault();
        var closestDropdown = $(event.target).closest('.site-nav--has-dropdown');
        if (closestDropdown.hasClass('submenu-visible')) {
            closestDropdown.removeClass('submenu-visible');
            closestDropdown.find('i:first').removeClass("fa-minus").addClass("fa-plus");
        } else {
          closestDropdown.addClass('submenu-visible');
          closestDropdown.find('i:first').removeClass("fa-plus").addClass("fa-minus");
          
        }
    });
  $('.jdgm-prev-badge__stars, .jdgm-prev-badge__text').click('on', function(){
  
   });


    // const interval = setInterval(() => {
    //     const dropdown = $('.jdgm-sort-dropdown');
    //     if (dropdown.length > 0) {
    //         dropdown.val('pictures-first').trigger('change');
    //         // Force a redraw if necessary
    //         dropdown.trigger('blur').trigger('focus');
    //         clearInterval(interval); // Stop checking
    //     }
    // }, 100);
 
});


